/**
 * Format a number into a short price string (e.g., 3000K, 3M)
 * @param {number} amount - The amount to format
 * @param {string} currency - Optional currency symbol (e.g., "Rp", "$")
 * @returns {string} - Formatted short price string
 */
export function formatPriceShort(amount: number | string, currency = '') {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numAmount)) {
        throw new Error("Invalid amount");
    }

    let formatted = "";
    if (numAmount >= 1_000_000) {
        // For millions
        formatted = `${(numAmount / 1_000).toFixed(1)}K`;
    } else if (numAmount >= 1_000) {
        // For thousands
        formatted = `${(numAmount / 1_000).toFixed(1)}K`;
    } else {
        // For less than a thousand
        formatted = numAmount.toString();
    }

    return currency ? `${currency}${formatted}` : formatted;
}

/**
 * Format a number into a price string (e.g., "Rp 3.000.000")
 * @param {number} amount - The amount to format
 * @param {string} currency - Optional currency symbol (e.g., "IDR", "USD")
 * @param {string} locale - Optional locale for formatting (default: "id-ID")
 * @returns {string} - Formatted price string with currency symbol, example: "Rp 3.000.000"
 */
export function formatPrice(amount: number | string, currency = "IDR", locale = "id-ID") {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numAmount)) {
        throw new Error("Invalid amount, must be a valid number.");
    }

    // Define currency symbols for better display
    const currencySymbols: Record<string, string> = {
        IDR: "Rp",
        USD: "$",
        EUR: "€",
        GBP: "£",
        JPY: "¥",
    };

    // Get the currency symbol or fallback to the currency code
    const currencySymbol = currencySymbols[currency] || currency;

    // Format the price with locale and currency symbol
    return `${currencySymbol} ${numAmount.toLocaleString(locale)}`;
}

// /**
//  * Format a number into a price string (e.g., "Rp 3.000.000")
//  * @param {number} amount - The amount to format
//  * @param {string} currency - Currency symbol (default: "IDR")
//  * @param {string} locale - Locale for formatting (default: "id-ID")
//  * @returns {string} - Formatted price string, example: "Rp 3.000.000"
//  */
// export function formatPrice(amount: number, currency = "IDR", locale = "id-ID"): string {
//     if (isNaN(amount) || !isFinite(amount)) {
//         console.error("Invalid amount provided:", amount);
//         return "Rp 0"; // Fallback untuk nilai yang tidak valid
//     }

//     // Daftar simbol mata uang
//     const currencySymbols: Record<string, string> = {
//         IDR: "Rp",
//         USD: "$",
//         EUR: "€",
//         GBP: "£",
//         JPY: "¥",
//         AUD: "A$",
//         CAD: "C$",
//         CHF: "CHF",
//         CNY: "¥",
//         SGD: "S$",
//     };

//     // Ambil simbol atau gunakan kode mata uang jika tidak tersedia
//     const currencySymbol = currencySymbols[currency] || currency;

//     // Format angka dengan pemisah ribuan dan dua desimal (jika diperlukan)
//     return `${currencySymbol} ${Math.abs(amount).toLocaleString(locale, {
//         minimumFractionDigits: 0,
//         maximumFractionDigits: 2,
//     })}`;
// }